"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4742],{

/***/ 93721:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = __webpack_require__(34885);
var _useProductsAndFiltersFromCategory = __webpack_require__(42807);
var _LanguageProvider = __webpack_require__(8989);
var _cache = __webpack_require__(75800);
var _createFilterString = _interopRequireDefault(__webpack_require__(44306));
var _replaceSpecialCharacters = _interopRequireDefault(__webpack_require__(64426));
var _addSortFilters = _interopRequireDefault(__webpack_require__(58478));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _filters = __webpack_require__(60461);
var _excluded = ["sort"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useFilters = function useFilters(initialProducts, categoryId, initialFilters, initialPage, allFilters, router, pageSize, isFirstRun, cacheSSR) {
  var _initialFilters$filte, _initialFilters$filte2;
  var disabledFilters = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useState = (0, _react.useState)(false),
    isPending = _useState[0],
    setPending = _useState[1];
  var translations = {
    recommended: (0, _langLibrary["default"])("recommended"),
    priceCatalogHigh: (0, _langLibrary["default"])("price catalog low to high"),
    priceCatalogLow: (0, _langLibrary["default"])("price catalog high to low"),
    finalPriceHigh: (0, _langLibrary["default"])("price low to high"),
    finalPriceLow: (0, _langLibrary["default"])("price high to low"),
    sortByNameDesc: (0, _langLibrary["default"])("sortByNameDesc"),
    sortByNameAsc: (0, _langLibrary["default"])("sortByNameAsc")
  };
  var _useState2 = (0, _react.useState)({
      products: initialProducts,
      activeFilters: initialFilters,
      productsAmount: false,
      page: initialPage,
      currentCategory: categoryId,
      pickedFiltersKeys: (_initialFilters$filte = initialFilters === null || initialFilters === void 0 ? void 0 : (_initialFilters$filte2 = initialFilters.filter(function (filter) {
        return filter.value;
      })) === null || _initialFilters$filte2 === void 0 ? void 0 : _initialFilters$filte2.map(function (filter) {
        return filter.id;
      })) !== null && _initialFilters$filte !== void 0 ? _initialFilters$filte : [],
      allFilters: allFilters
    }),
    filtersState = _useState2[0],
    setFiltersState = _useState2[1];
  (0, _react.useEffect)(function () {
    var _initialFilters$map;
    if (isPending) return;
    setFiltersState(_objectSpread(_objectSpread({}, filtersState), {}, {
      products: initialProducts,
      activeFilters: (_initialFilters$map = initialFilters === null || initialFilters === void 0 ? void 0 : initialFilters.map(function (filter) {
        if (disabledFilters !== null && disabledFilters !== void 0 && disabledFilters.includes(filter.id)) {
          return _objectSpread(_objectSpread({}, filter), {}, {
            isDisabled: true
          });
        }
        if (filter.id === "capacity") {
          var _filter$value, _filter$value2, _filter$value3;
          return ((_filter$value = filter.value) === null || _filter$value === void 0 ? void 0 : _filter$value.to) !== undefined ? _objectSpread(_objectSpread({}, filter), {}, {
            value: {
              to: ((_filter$value2 = filter.value) === null || _filter$value2 === void 0 ? void 0 : _filter$value2.to) / 1000,
              from: ((_filter$value3 = filter.value) === null || _filter$value3 === void 0 ? void 0 : _filter$value3.from) / 1000
            },
            isConverted: true,
            max: filter.max / 1000,
            min: filter.min / 1000
          }) : _objectSpread(_objectSpread({}, filter), {}, {
            isConverted: true,
            max: filter.max / 1000,
            min: filter.min / 1000
          });
        }
        return filter;
      })) !== null && _initialFilters$map !== void 0 ? _initialFilters$map : [],
      currentCategory: categoryId,
      page: initialPage
    }));
  }, [initialFilters, categoryId, initialProducts]);
  var onFiltersChange = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(filtersValue) {
      var _pickedFilters$sort, _pickedFilters$sort2, _url;
      var page,
        requestPath,
        categories,
        currentCategory,
        prismicCategory,
        proCategoryString,
        _filtersReduce,
        pickedFilters,
        pickedFiltersKeys,
        newlyPickedFilterKey,
        sort,
        pickedValueWithoutSort,
        filtersRangeString,
        pageString,
        url,
        isSort,
        sortString,
        urlToCheck,
        responseFromCache,
        response,
        newFilters,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              requestPath = _args.length > 2 ? _args[2] : undefined;
              categories = _args.length > 3 ? _args[3] : undefined;
              currentCategory = _args.length > 4 ? _args[4] : undefined;
              prismicCategory = _args.length > 5 ? _args[5] : undefined;
              proCategoryString = _args.length > 6 && _args[6] !== undefined ? _args[6] : false;
              setPending(true);
              _filtersReduce = (0, _filters.filtersReduce)(filtersValue, filtersState.pickedFiltersKeys), pickedFilters = _filtersReduce.pickedFilters, pickedFiltersKeys = _filtersReduce.pickedFiltersKeys, newlyPickedFilterKey = _filtersReduce.newlyPickedFilterKey;
              sort = pickedFilters.sort, pickedValueWithoutSort = (0, _objectWithoutProperties2["default"])(pickedFilters, _excluded);
              filtersRangeString = "";
              Object.keys(pickedValueWithoutSort).map(function (filter) {
                if (filter === "capacity") {
                  pickedValueWithoutSort[filter] = _objectSpread(_objectSpread({}, pickedValueWithoutSort[filter]), {}, {
                    from: pickedValueWithoutSort[filter].from / 1000,
                    to: pickedValueWithoutSort[filter].to / 1000
                  });
                }
                if (!Array.isArray(pickedValueWithoutSort[filter])) {
                  filtersRangeString += "".concat(filtersRangeString ? "-" : "").concat(filter, "-").concat(pickedValueWithoutSort[filter].from, "-").concat(pickedValueWithoutSort[filter].to);
                  delete pickedValueWithoutSort[filter];
                } else {
                  var pickedValue = pickedValueWithoutSort[filter].map(function (filter) {
                    return filter.name.toLowerCase();
                  }).flat();
                  filtersRangeString += "".concat(filtersRangeString ? "-" : "").concat(pickedValue === null || pickedValue === void 0 ? void 0 : pickedValue.join("-"));
                  delete pickedValueWithoutSort[filter];
                }
              });
              if (filtersRangeString) {
                filtersRangeString = "/".concat(filtersRangeString).replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_");
              }
              pageString = page > 1 ? "p=".concat(page) : null;
              isSort = (pickedFilters === null || pickedFilters === void 0 ? void 0 : (_pickedFilters$sort = pickedFilters["sort"]) === null || _pickedFilters$sort === void 0 ? void 0 : _pickedFilters$sort.value) && (pickedFilters === null || pickedFilters === void 0 ? void 0 : (_pickedFilters$sort2 = pickedFilters["sort"]) === null || _pickedFilters$sort2 === void 0 ? void 0 : _pickedFilters$sort2.value.split("-"));
              sortString = isSort ? "?dir=" + (isSort === null || isSort === void 0 ? void 0 : isSort[1]) + "&order=" + (isSort === null || isSort === void 0 ? void 0 : isSort[0]) : "";
              url = "".concat(requestPath).concat(filtersRangeString).concat(sortString);
              if (pageString) {
                url = "".concat(url).concat(url.includes("?") ? "&" + pageString : "?" + pageString);
              }
              url = (0, _replaceSpecialCharacters["default"])(url);
              urlToCheck = proCategoryString ? proCategoryString : "".concat(((_url = url) === null || _url === void 0 ? void 0 : _url[0]) !== "/" ? "/" : "").concat(url);
              responseFromCache = (0, _cache.getResultFromCache)(urlToCheck, cacheSSR);
              if (!(responseFromCache !== null && responseFromCache !== void 0)) {
                _context.next = 24;
                break;
              }
              _context.t0 = responseFromCache;
              _context.next = 27;
              break;
            case 24:
              _context.next = 26;
              return (0, _useProductsAndFiltersFromCategory.fetcher)(categoryId, pickedFilters, page, pageSize, null, language);
            case 26:
              _context.t0 = _context.sent;
            case 27:
              response = _context.t0;
              (0, _addSortFilters["default"])(response === null || response === void 0 ? void 0 : response.narrowedFilters, translations);
              filtersValue = Array.isArray(filtersValue) ? filtersValue : [filtersValue];
              newFilters = (0, _filters.filtersSetValue)(response === null || response === void 0 ? void 0 : response.narrowedFilters, filtersValue, newlyPickedFilterKey, pickedFiltersKeys);
              if (!responseFromCache) {
                (0, _cache.setUrlInCache)(proCategoryString ? proCategoryString : "/".concat(url), _objectSpread(_objectSpread({}, response), {}, {
                  categories: categories,
                  currentCategory: currentCategory,
                  prismicCategory: prismicCategory
                }), cacheSSR);
              }
              setFiltersState({
                page: page,
                productsAmount: response.productsTotalCount,
                activeFilters: newFilters,
                products: response.products,
                previousCategory: filtersState.currentCategory,
                currentCategory: categoryId,
                pickedFiltersKeys: pickedFiltersKeys,
                allFilters: filtersState.allFilters
              });
              setPending(false);
              return _context.abrupt("return", (0, _createFilterString["default"])(newFilters));
            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onFiltersChange(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    products: filtersState.products,
    page: initialPage,
    productsAmount: filtersState.previousCategory !== filtersState.currentCategory ? false : filtersState.productsAmount,
    activeFilters: filtersState.activeFilters,
    onFiltersChange: onFiltersChange
  };
};
var _default = useFilters;
exports.Z = _default;

/***/ }),

/***/ 88605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.mapToNewFiltersStructure = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50415));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _agent = __webpack_require__(37642);
var _mapProductDataNew = _interopRequireDefault(__webpack_require__(69729));
var _moveOutOfStockProductsLast = _interopRequireDefault(__webpack_require__(97831));
var _getSearchUrl = _interopRequireDefault(__webpack_require__(40408));
var _createSearchUrl = __webpack_require__(8371);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapToNewFiltersStructure = function mapToNewFiltersStructure(item) {
  var newItem = _objectSpread(_objectSpread({}, item), {}, {
    label: item.name
  });
  if (item.items) {
    newItem.options = item.items.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        label: option.name,
        id: option.id + ""
      });
    });
  }
  if (item.type === "color") {
    newItem.type = "multiselect";
  }
  if (item.type === "select") {
    newItem.type = "multiselect";
  }
  return newItem;
};
exports.mapToNewFiltersStructure = mapToNewFiltersStructure;
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(categoryId) {
    var pickedFilters,
      page,
      pageSize,
      query,
      language,
      productsFromCategoryMapped,
      filters,
      narrowedFilters,
      productsTotalCount,
      _yield$Promise$all,
      _yield$Promise$all2,
      productsFromCategory,
      filtersResponse,
      pickedFiltersList,
      allPositionFromPickedFilter,
      currentFiltersWithPickedFilter,
      mappedProducts,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pickedFilters = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            page = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
            pageSize = _args.length > 3 && _args[3] !== undefined ? _args[3] : __webpack_require__.g.__appConfig__.categoryPageSize;
            query = _args.length > 4 && _args[4] !== undefined ? _args[4] : null;
            language = _args.length > 5 ? _args[5] : undefined;
            productsTotalCount = 0;
            _context.prev = 6;
            _context.next = 9;
            return Promise.all([_agent.requests.get((0, _getSearchUrl["default"])({
              url: "/products",
              currentPage: page,
              query: query,
              pageSize: pageSize,
              pickedFilters: pickedFilters,
              categoryId: categoryId,
              lang: language
            }).replace((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.elasticEndpointUrl, {
              lang: language.language,
              domain: language.domain
            }), ""), true, null, language), categoryId ? _agent.requests.get((0, _createSearchUrl.createSearchUrl)("/deosite/filters/list", [{
              field: "category_id",
              condition_type: "eq",
              value: categoryId,
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "visibility",
              condition_type: "in",
              value: [2, 4],
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "type_id",
              value: "simple",
              connector: _createSearchUrl.CONNECTORS.AND
            }]), true, null, language) : {}]);
          case 9:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
            productsFromCategory = _yield$Promise$all2[0];
            filtersResponse = _yield$Promise$all2[1];
            if (filtersResponse !== null && filtersResponse !== void 0 && filtersResponse.items) {
              filters = filtersResponse.items.map(mapToNewFiltersStructure);
            } else if (productsFromCategory.filters.items) {
              filters = productsFromCategory.filters.items.map(mapToNewFiltersStructure);
            }
            pickedFiltersList = Object.keys(pickedFilters);
            if (productsFromCategory.filters.items && pickedFiltersList.length > 1) {
              narrowedFilters = productsFromCategory.filters.items.map(mapToNewFiltersStructure);
            } else if (productsFromCategory.filters.items && pickedFiltersList.length === 1) {
              allPositionFromPickedFilter = filters.map(mapToNewFiltersStructure).find(function (filter) {
                return filter.id === (pickedFiltersList === null || pickedFiltersList === void 0 ? void 0 : pickedFiltersList[0]);
              });
              currentFiltersWithPickedFilter = productsFromCategory.filters.items.map(mapToNewFiltersStructure).map(function (filter) {
                if (filter.id === (pickedFiltersList === null || pickedFiltersList === void 0 ? void 0 : pickedFiltersList[0])) {
                  return allPositionFromPickedFilter;
                }
                return filter;
              });
              narrowedFilters = (0, _toConsumableArray2["default"])(currentFiltersWithPickedFilter);
            } else {
              narrowedFilters = filters;
            }
            if (pickedFilters["sort"]) {
              narrowedFilters.push({
                id: "sort",
                value: pickedFilters["sort"]
              });
            }
            if (filters) {
              filters.forEach(function (filter) {
                if (pickedFilters[filter.id]) {
                  if (filter.type === "multiselect") {
                    filter.value = pickedFilters[filter.id];
                  }
                }
              });
            }
            if (narrowedFilters) {
              narrowedFilters.forEach(function (filter) {
                if (pickedFilters[filter.id]) {
                  if (filter.type === "range") {
                    var _filtersResponse$item;
                    var initialFilter = (_filtersResponse$item = filtersResponse.items) === null || _filtersResponse$item === void 0 ? void 0 : _filtersResponse$item.find(function (initialFilter) {
                      return initialFilter.id === filter.id;
                    });
                    if (initialFilter) {
                      filter.min = initialFilter.min;
                      filter.max = initialFilter.max;
                    }
                  }
                  filter.value = pickedFilters[filter.id];
                }
              });
            }
            if (productsFromCategory.total_count > 0) {
              mappedProducts = (0, _mapProductDataNew["default"])(productsFromCategory.items);
              productsFromCategoryMapped = (pickedFiltersList === null || pickedFiltersList === void 0 ? void 0 : pickedFiltersList.length) === 0 ? (0, _moveOutOfStockProductsLast["default"])(mappedProducts) : mappedProducts;
              productsTotalCount = productsFromCategory.total_count;
            } else {
              productsFromCategoryMapped = [];
            }
            _context.next = 26;
            break;
          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](6);
            console.log("There was an error while fetching products from products and filters from category ".concat(categoryId, " ").concat(_context.t0));
            productsFromCategoryMapped = [];
          case 26:
            return _context.abrupt("return", {
              products: productsFromCategoryMapped,
              productsTotalCount: productsTotalCount,
              filters: filters,
              narrowedFilters: narrowedFilters
            });
          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 22]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 42807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "useProductsAndFiltersFromCategory", ({
  enumerable: true,
  get: function get() {
    return _useProductsAndFiltersFromCategory["default"];
  }
}));
Object.defineProperty(exports, "fetcher", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
exports["default"] = void 0;
var _useProductsAndFiltersFromCategory = _interopRequireDefault(__webpack_require__(25927));
var _fetcher = _interopRequireDefault(__webpack_require__(88605));
var _default = _useProductsAndFiltersFromCategory["default"];
exports["default"] = _default;

/***/ }),

/***/ 25927:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _cache = __webpack_require__(75800);
var _addSortFilters = _interopRequireDefault(__webpack_require__(58478));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useProductsAndFiltersFromCategory = function useProductsAndFiltersFromCategory(categoryId, pickedFilters, page, pageSize, query, lang, fetchedData, router, cacheSSR) {
  var _data$filters;
  var translations = {
    recommended: (0, _langLibrary["default"])("recommended"),
    priceCatalogHigh: (0, _langLibrary["default"])("price catalog low to high"),
    priceCatalogLow: (0, _langLibrary["default"])("price catalog high to low"),
    finalPriceHigh: (0, _langLibrary["default"])("price low to high"),
    finalPriceLow: (0, _langLibrary["default"])("price high to low"),
    sortByNameDesc: (0, _langLibrary["default"])("sortByNameDesc"),
    sortByNameAsc: (0, _langLibrary["default"])("sortByNameAsc")
  };
  var fetchedDataCache = (0, _cache.getResultFromCache)(decodeURI(router.asPath).replace(/p=[0-9]*/, "p=".concat(page)), cacheSSR);
  var data = fetchedDataCache !== null && fetchedDataCache !== void 0 ? fetchedDataCache : fetchedData;
  if (!((_data$filters = data.filters) !== null && _data$filters !== void 0 && _data$filters.find(function (filter) {
    return filter.id === "sort";
  }))) {
    (0, _addSortFilters["default"])(data.filters, translations, true);
  }
  (0, _addSortFilters["default"])(data.narrowedFilters, translations);
  return {
    data: _objectSpread({}, data)
  };
};
var _default = useProductsAndFiltersFromCategory;
exports["default"] = _default;

/***/ }),

/***/ 58478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var addSortFilters = function addSortFilters(filters, translations) {
  var _global$__appConfig__;
  var addWithoutValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var forSearchPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var sortFound = filters === null || filters === void 0 ? void 0 : filters.find(function (filter) {
    return filter.id === "sort";
  });
  var options = [{
    id: "position-desc",
    value: "position-desc",
    label: translations.recommended
  }, {
    id: "final_price-desc",
    value: "final_price-desc",
    label: translations.finalPriceLow
  }, {
    id: "final_price-asc",
    value: "final_price-asc",
    label: translations.finalPriceHigh
  }, {
    id: "name-desc",
    value: "name-desc",
    label: translations.sortByNameDesc
  }, {
    id: "name-asc",
    value: "name-asc",
    label: translations.sortByNameAsc
  }];
  if ((_global$__appConfig__ = __webpack_require__.g.__appConfig__.showSortByCatalogPrice) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : true) {
    options.push({
      id: "price-desc",
      value: "price-desc",
      label: translations.priceCatalogLow
    });
    options.push({
      id: "price-asc",
      value: "price-asc",
      label: translations.priceCatalogHigh
    });
  }
  var sort = {
    id: "sort",
    label: "Sort",
    type: "select",
    options: options,
    value: sortFound ? sortFound.value : null
  };
  if (forSearchPage) {
    sort.options.splice(0, 1);
  }
  if (sortFound && !addWithoutValue) {
    filters[filters.length - 1] = sort;
  } else {
    filters === null || filters === void 0 ? void 0 : filters.push(sort);
  }
  return filters;
};
var _default = addSortFilters;
exports["default"] = _default;

/***/ }),

/***/ 54801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _propTypes = _interopRequireDefault(__webpack_require__(8131));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Category = {};
var categoryProps = {
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].number.isRequired,
  level: _propTypes["default"].number.isRequired,
  url: _propTypes["default"].string.isRequired,
  backgroundColorImage: _propTypes["default"].string,
  image: _propTypes["default"].object,
  label: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  subcategories: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].number.isRequired,
    modeImageBar: _propTypes["default"].string,
    backgroundColorImage: _propTypes["default"].string,
    image: _propTypes["default"].object,
    columnInMenu: _propTypes["default"].number,
    positionInColumn: _propTypes["default"].number
  }))), _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].number.isRequired,
    modeImageBar: _propTypes["default"].string,
    backgroundColorImage: _propTypes["default"].string,
    image: _propTypes["default"].object,
    columnInMenu: _propTypes["default"].number,
    positionInColumn: _propTypes["default"].number
  }))])
};
Category.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, categoryProps[prop]));
  }, {})) : _propTypes["default"].shape(categoryProps);
};
var _default = Category;
exports["default"] = _default;

/***/ }),

/***/ 37250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _propTypes = _interopRequireDefault(__webpack_require__(8131));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Collection = {};
var collectionProps = {
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  content: _propTypes["default"].string,
  colors: _propTypes["default"].arrayOf(_propTypes["default"].string),
  moreAvailable: _propTypes["default"].number,
  lowestPrice: _propTypes["default"].number,
  mainImage: _propTypes["default"].object,
  thumbnails: _propTypes["default"].arrayOf(_propTypes["default"].object),
  cardLink: _propTypes["default"].string
};
Collection.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, collectionProps[prop]));
  }, {})) : _propTypes["default"].shape(collectionProps);
};
var _default = Collection;
exports["default"] = _default;

/***/ }),

/***/ 47516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var __jsx = _react["default"].createElement;
var CategoriesSliderMobile = function CategoriesSliderMobile(props) {
  var categories = props.categories;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      overflowY: "hidden",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      "::-webkit-scrollbar": {
        display: "none"
      },
      scrollbarWidth: "none"
    }
  }, categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) {
    return __jsx(Link, {
      route: "category-page",
      params: category,
      key: index
    }, __jsx(_LinkRaw["default"], {
      title: category.name,
      sx: {
        display: "flex",
        alignItems: "center",
        height: "36px",
        color: "main",
        marginRight: "s5",
        borderColor: "neutral",
        borderStyle: "solid",
        borderWidth: "1px",
        flex: "0 0 auto",
        font: "xs_caps",
        borderRadius: "5px",
        px: "s6"
      }
    }, category.name));
  }));
};
var _default = CategoriesSliderMobile;
exports.Z = _default;

/***/ }),

/***/ 31265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _usePriceWithCurrency = _interopRequireDefault(__webpack_require__(81890));
var _Collection = _interopRequireDefault(__webpack_require__(37250));
var _core = __webpack_require__(79329);
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CollectionCard = function CollectionCard(props) {
  var collection = props.collection;
  var translations = {
    startingAt: (0, _langLibrary["default"])("starting at"),
    more: (0, _langLibrary["default"])("more")
  };
  var title = collection.title,
    subtitle = collection.subtitle,
    colors = collection.colors,
    moreAvailable = collection.moreAvailable,
    lowestPrice = collection.lowestPrice,
    mainImage = collection.mainImage,
    thumbnails = collection.thumbnails,
    link = collection.link;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Box["default"], {
    sx: {
      pb: "s7",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "grid",
      gridTemplateColumns: "2.7fr 1fr",
      gridTemplateRows: "auto auto",
      gap: "1px"
    }
  }, __jsx(_Image["default"], {
    image: mainImage,
    sx: {
      gridColumn: 1,
      gridRow: "1 / span 2",
      aspectRatio: 0.75
    },
    overlay: true
  }), thumbnails && thumbnails.slice(0, 2).map(function (thumbnail, index) {
    return __jsx(_Image["default"], {
      image: thumbnail,
      sx: {
        gridColumn: 2,
        gridRow: index === 0 ? 1 : 2,
        aspectRatio: 1,
        $objectFit: "cover"
      },
      overlay: true,
      key: index
    });
  })), __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "heading3",
      textAlign: "left",
      pr: "s7",
      mt: "s7",
      mb: "s5",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "center"
    },
    as: "h3"
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      mr: "s6",
      display: "block"
    }
  }, title), " ", __jsx(ArrowRightIcon, null)), __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      font: "xs",
      pr: "s7",
      textAlign: "left"
    }
  }, subtitle, lowestPrice && translations.startingAt + " " + priceWithCurrency(lowestPrice)), __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      pr: "s7",
      mt: "s5"
    }
  }, colors && colors.slice(0, 5).map(function (color, index) {
    return __jsx(_Box["default"], {
      sx: {
        bg: color,
        display: "inline-block",
        width: "16px",
        height: "16px",
        mr: 1,
        border: "1px",
        borderStyle: "solid",
        borderColor: "neutral"
      },
      key: index
    }, "\xA0");
  }), colors && colors.length > 0 && moreAvailable && __jsx(_Box["default"], {
    sx: {
      pl: (0, _core.lin)("s7", "s5")
    },
    as: "span"
  }, moreAvailable > 0 && "+" + moreAvailable + " " + translations.more)), __jsx(Link, {
    route: link
  }, __jsx(_LinkRaw["default"], {
    title: title,
    sx: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%"
    }
  })));
};
var _default = CollectionCard;
exports.Z = _default;

/***/ }),

/***/ 99240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Collection = _interopRequireDefault(__webpack_require__(37250));
var _prismicReactjs = __webpack_require__(56410);
var __jsx = _react["default"].createElement;
var CollectionDetails = function CollectionDetails(props) {
  var collection = props.collection;
  var title = collection.title,
    content = collection.content;
  return __jsx(_Box["default"], {
    sx: {
      py: "s9"
    }
  }, title && __jsx(_Box["default"], {
    as: "h5",
    sx: {
      textAlign: "left",
      font: "heading3",
      mb: "s7"
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      textAlign: "left",
      font: "body",
      li: {
        mt: "s7",
        listStyleType: "disc",
        pl: "s5"
      },
      ul: {
        pl: "s8"
      },
      p: {
        mt: "s5"
      },
      h5: {
        font: "heading3",
        mb: "s7"
      },
      a: {
        color: "main"
      }
    }
  }, _prismicReactjs.RichText.render(content)));
};
var _default = CollectionDetails;
exports.Z = _default;

/***/ }),

/***/ 11316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Influencer = _interopRequireDefault(__webpack_require__(28901));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var __jsx = _react["default"].createElement;
var InfluencerBio = function InfluencerBio(props) {
  var _props$influencerData = props.influencerData,
    image = _props$influencerData.image,
    name = _props$influencerData.name,
    url = _props$influencerData.url,
    username = _props$influencerData.username,
    description = _props$influencerData.description;
  return __jsx(_Box["default"], {
    sx: {
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      borderTopColor: "neutral500",
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: "neutral500",
      pt: "s9",
      pb: "s9",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "80px",
      height: "80px",
      borderRadius: "80px",
      overflow: "hidden"
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1
    },
    minified: true,
    image: image
  })), __jsx(_Box["default"], {
    sx: {
      ml: "s8",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s"
    }
  }, name), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s_italic"
    }
  }, __jsx(_LinkRaw["default"], {
    href: url,
    target: "_blank",
    title: name
  }, "@" + username)))), __jsx(_Box["default"], {
    sx: {
      font: "base",
      mt: "s9"
    }
  }, description));
};
var _default = InfluencerBio;
exports.Z = _default;

/***/ }),

/***/ 71745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Inspiration = _interopRequireDefault(__webpack_require__(74320));
var __jsx = _react["default"].createElement;
var InspirationHeader = function InspirationHeader(props) {
  var inspiration = props.inspiration,
    _onClick = props.onClick,
    button = props.button;
  var influencerData = inspiration.influencerData,
    title = inspiration.title;
  var image = influencerData.image,
    name = influencerData.name,
    url = influencerData.url,
    username = influencerData.username;
  var translations = {
    curatedBy: (0, _langLibrary["default"])("Curated by"),
    shopItemsBelow: (0, _langLibrary["default"])("Shop items below"),
    from: (0, _langLibrary["default"])("from")
  };
  var inspirationHeaderButton = /*#__PURE__*/_react["default"].cloneElement(button, {
    onClick: function onClick() {
      return _onClick;
    }
  }, translations.shopItemsBelow);
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      mt: "s8",
      mb: "s8",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      mb: "s7",
      font: "xl",
      textAlign: "center",
      width: "80%"
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      width: 80,
      height: 80,
      borderRadius: 80,
      overflow: "hidden"
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1
    },
    image: image
  })), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s"
    }
  }, translations.curatedBy), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      font: "s",
      mb: "s8"
    }
  }, __jsx(_Box["default"], null, name), "\xA0", translations.from, "\xA0", __jsx(_Box["default"], {
    sx: {
      font: "s_italic"
    }
  }, __jsx(_LinkRaw["default"], {
    href: url,
    target: "_blank",
    title: name
  }, " @" + username))), __jsx(_Box["default"], {
    sx: {
      display: ["block", null, "none"]
    }
  }, inspirationHeaderButton));
};
var _default = InspirationHeader;
exports.Z = _default;

/***/ }),

/***/ 44325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LABEL_MODE = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LABEL_MODE = {
  labelDefault: "Default label on the bottom",
  labelRight: "label on the left",
  labelRightSmallerCircle: "label on the left smaller image"
};
exports.LABEL_MODE = LABEL_MODE;
Object.freeze(LABEL_MODE);
var defaultProps = {
  labelMode: LABEL_MODE.labelDefault,
  additionalLabel: false
};
var LabelWithImage = function LabelWithImage(props) {
  var image = props.image,
    url = props.url,
    _props$labelMode = props.labelMode,
    labelMode = _props$labelMode === void 0 ? defaultProps.labelMode : _props$labelMode,
    _props$additionalLabe = props.additionalLabel,
    additionalLabel = _props$additionalLabe === void 0 ? defaultProps.additionalLabel : _props$additionalLabe,
    id = props.id;
  var translations = {
    "new": (0, _langLibrary["default"])("new")
  };
  var label = props.label;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var circle = function circle(mode) {
    var mainCategoryCirclePercent = "80px";
    var subCategoryCirclePercent = "50px";
    var defaultCirclePercent = "100%";
    if (mode === LABEL_MODE.labelRight) {
      return mainCategoryCirclePercent;
    } else if (mode === LABEL_MODE.labelRightSmallerCircle) {
      return subCategoryCirclePercent;
    }
    return defaultCirclePercent;
  };
  var isDefaultLabel = labelMode === LABEL_MODE.labelDefault;
  var circleSize = circle(labelMode);
  var flexRowCss = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "nowrap"
  };
  var defaultColor = {
    color: "inherit"
  };
  var specialCategoryCss = {
    color: "negative"
  };
  var blackCategoryCss = {
    color: "white"
  };
  var boxingCategoryCss = {
    color: "white"
  };
  var sx = defaultColor;
  if (parseInt(id) === __webpack_require__.g.__appConfig__.specialCategoryId) {
    sx = specialCategoryCss;
  }
  if (parseInt(id) === __webpack_require__.g.__appConfig__.blackCategoryId) {
    sx = blackCategoryCss;
  }
  if (parseInt(id) === __webpack_require__.g.__appConfig__.boxingCategoryId) {
    sx = boxingCategoryCss;
  }
  var labelWithImage = __jsx(_Box["default"], {
    sx: _objectSpread({
      width: "100%",
      font: "xs_caps"
    }, sx)
  }, __jsx(_Box["default"], {
    sx: isDefaultLabel ? {} : flexRowCss
  }, image && __jsx(_Box["default"], {
    sx: {
      borderRadius: "50%",
      overflow: "hidden",
      position: "relative",
      flexBasis: circleSize,
      width: circleSize,
      height: circleSize,
      minWidth: circleSize
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1,
      objectFit: "cover"
    },
    image: image
  })), __jsx(_Box["default"], {
    sx: isDefaultLabel ? _objectSpread({
      mt: "s4",
      textAlign: "center",
      flexGrow: "1",
      alignItems: "center"
    }, flexRowCss) : {
      ml: image ? "s7" : "s0",
      flexGrow: "1",
      display: "flex",
      flexDirection: "row"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: labelMode === LABEL_MODE.labelDefault ? {
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": "3",
      overflow: "hidden",
      paddingLeft: "s5"
    } : {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      paddingLeft: "s5"
    }
  }, label), additionalLabel && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      minWidth: "50px"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      display: "block",
      ml: "s4",
      color: "main",
      minWidth: "2px",
      width: "2px",
      height: "2px",
      backgroundColor: "main"
    }
  }), __jsx(_Box["default"], {
    as: "p",
    sx: {
      display: "block",
      ml: "s4",
      color: "active"
    }
  }, translations["new"])))));
  return url ? __jsx(Link, {
    route: url
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, labelWithImage)) : labelWithImage;
};
var _default = LabelWithImage;
exports["default"] = _default;

/***/ }),

/***/ 81023:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _LabelWithImage = _interopRequireWildcard(__webpack_require__(44325));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));
var _excluded = ["label", "image", "labelMode", "additionalLabel", "isArrowShown", "id"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var MenuArrowIcon = function MenuArrowIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }));
};
MenuArrowIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  isArrowShown: true,
  labelMode: _LabelWithImage.LABEL_MODE.labelDefault
};
var MenuItemButton = function MenuItemButton(props) {
  var label = props.label,
    image = props.image,
    _props$labelMode = props.labelMode,
    labelMode = _props$labelMode === void 0 ? defaultProps.labelMode : _props$labelMode,
    additionalLabel = props.additionalLabel,
    _props$isArrowShown = props.isArrowShown,
    isArrowShown = _props$isArrowShown === void 0 ? defaultProps.isArrowShown : _props$isArrowShown,
    id = props.id,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return __jsx(_ButtonRaw["default"], restProps, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "&:hover": {
        svg: {
          opacity: 1
        }
      },
      svg: {
        opacity: [1, null, null, 0],
        transition: "opacity .1s"
      }
    }
  }, __jsx(_LabelWithImage["default"], {
    label: label,
    id: id,
    image: image,
    labelMode: labelMode,
    additionalLabel: additionalLabel
  }), isArrowShown && __jsx(_Box["default"], {
    sx: {
      width: "24px",
      height: "24px",
      fill: "main"
    }
  }, __jsx(MenuArrowIcon, null))));
};
var _default = MenuItemButton;
exports["default"] = _default;

/***/ }),

/***/ 17951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Product = _interopRequireDefault(__webpack_require__(71438));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
var SquareCardWithLabel = function SquareCardWithLabel(props) {
  var productData = props.productData;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(Link, {
    route: productData.url
  }, __jsx(_LinkRaw["default"], {
    sx: {
      textAlign: "center",
      font: "body2",
      color: "main"
    }
  }, __jsx(_Image["default"], {
    overlay: true,
    sx: {
      marginBottom: "s4"
    },
    sizes: "(max-width: 1350px) and (min-width: 10px) 210px, 420px",
    image: productData.image
  }), productData.name));
};
var _default = SquareCardWithLabel;
exports["default"] = _default;

/***/ }),

/***/ 7121:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _cache = __webpack_require__(75800);
var _getPickedFilters = __webpack_require__(21770);
var _separateFiltersAndSortFromUrl = _interopRequireWildcard(__webpack_require__(60926));
var _categoryThemes = _interopRequireDefault(__webpack_require__(52835));
var _rootCategory = __webpack_require__(84660);
var _removeSlash = _interopRequireDefault(__webpack_require__(6074));
var _getLastNumbersFromString = _interopRequireDefault(__webpack_require__(8233));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getPageSize = function getPageSize(theme) {
  return theme === _categoryThemes["default"].CATEGORY || theme === _categoryThemes["default"].MAIN || theme === _categoryThemes["default"].BRAND || theme === null ? __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange : __webpack_require__.g.__appConfig__.categoryPageSize;
};
var activeFiltersPro = function activeFiltersPro(category) {
  return category.length > 1 ? category[1] : "";
};
var categoryInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var context, productsAndFiltersFromCategoryFetcher, categoryFetcher, prismicFetcher, _ref$categoryWithPref, categoryWithPrefix, _context$query, category, initialPage, finalCategory, requestPath, activeFiltersString, language, cache, url, urlPrefix, cacheFilePath, _yield$readCacheFile, cacheFileExist, filenameCategoryCache, cachedRequest, _ref3, activeFilters, urlAfterQuestionMark, getPage, sortFilter, page, sortFilterTemporary, productsAndFiltersFromCache, _productsAndFiltersFr, _productsAndFiltersFr2, _yield$categoryFetche, currentCategory, _yield$Promise$all, _yield$Promise$all2, productsAndFilters, prismicCategory, availableFilters, pickedFilters, _getRangeFiltersAndRe, queryRangeFilters, queryFiltersWithRemovedRangeFiltersPart, _sort$, _sort$2, _sortFilter, sort, sortFiltersString, productsAndFiltersWithActiveFilters, result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = _ref.context, productsAndFiltersFromCategoryFetcher = _ref.productsAndFiltersFromCategoryFetcher, categoryFetcher = _ref.categoryFetcher, prismicFetcher = _ref.prismicFetcher, _ref$categoryWithPref = _ref.categoryWithPrefix, categoryWithPrefix = _ref$categoryWithPref === void 0 ? false : _ref$categoryWithPref;
            _context$query = context.query, category = _context$query.category, initialPage = _context$query.p;
            finalCategory = categoryWithPrefix ? (0, _getLastNumbersFromString["default"])(category === null || category === void 0 ? void 0 : category[0]) : category;
            requestPath = (0, _rootCategory.removeRootCategory)(context.query.requestPath);
            activeFiltersString = categoryWithPrefix ? activeFiltersPro(category) : (0, _removeSlash["default"])(context.query.activeFiltersString);
            language = context.language, cache = context.cache;
            url = context.asPath;
            urlPrefix = categoryWithPrefix ? url.includes("/l/") ? "l/" : "c/" : "";
            cacheFilePath = "".concat(language.language, "/cat/");
            _context.next = 11;
            return (0, _cache.readCacheFile)({
              cacheFilePath: cacheFilePath,
              contextRequest: context.req,
              requestPath: url[0] === "/" ? url.substring(1) : url
            });
          case 11:
            _yield$readCacheFile = _context.sent;
            cacheFileExist = _yield$readCacheFile.cacheFileExist;
            filenameCategoryCache = _yield$readCacheFile.filenameCategoryCache;
            cachedRequest = _yield$readCacheFile.cachedRequest;
            if (!cacheFileExist) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", _objectSpread(_objectSpread({}, cachedRequest), {}, {
              categories: context.categories,
              cache: cache
            }));
          case 17:
            _ref3 = categoryWithPrefix ? (0, _separateFiltersAndSortFromUrl.separateFiltersAndSortFromUrlPro)(activeFiltersString, url) : (0, _separateFiltersAndSortFromUrl["default"])(activeFiltersString, url), activeFilters = _ref3.activeFilters, urlAfterQuestionMark = _ref3.urlAfterQuestionMark;
            getPage = function getPage(page) {
              if (!page && typeof window !== "undefined") {
                var _window, _window$location$sear, _window2, _window2$location$sea;
                return (_window = window) !== null && _window !== void 0 && _window.location.pathname.includes(requestPath) ? (_window$location$sear = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location$sea = _window2.location.search.match(/p=(\d+)/)) === null || _window2$location$sea === void 0 ? void 0 : _window2$location$sea[1]) !== null && _window$location$sear !== void 0 ? _window$location$sear : 1 : 1;
              }
              return page;
            };
            page = getPage(initialPage);
            sortFilterTemporary = {
              dir: null,
              order: null
            };
            urlAfterQuestionMark === null || urlAfterQuestionMark === void 0 ? void 0 : urlAfterQuestionMark.split("&").map(function (query) {
              if (query.indexOf("dir") > -1) {
                sortFilterTemporary.dir = query;
              } else if (query.indexOf("order") > -1) {
                sortFilterTemporary.order = query;
              } else if (query.indexOf("p=") > -1) {
                var numberPage = parseInt(query === null || query === void 0 ? void 0 : query.slice(2));
                page = numberPage ? numberPage : 1;
                if (!numberPage) {
                  console.log("Problem with pagination in CategoryPage. query: ".concat(query, ", allQueryFilters: ").concat(activeFilters, " ").concat(urlAfterQuestionMark, ", requestPath: ").concat(requestPath, ", category: ").concat(category));
                }
              }
            });
            if (sortFilterTemporary.dir === null || sortFilterTemporary.order === null) {
              sortFilter = null;
            } else {
              sortFilter = sortFilterTemporary.dir + "&" + sortFilterTemporary.order;
            }
            _context.prev = 23;
            productsAndFiltersFromCache = (0, _cache.getResultFromCache)(url, cache);
            if (!productsAndFiltersFromCache) {
              _context.next = 29;
              break;
            }
            return _context.abrupt("return", {
              initialProductsAndFilters: productsAndFiltersFromCache,
              initialCurrentCategory: productsAndFiltersFromCache.currentCategory,
              categories: productsAndFiltersFromCache.categories,
              theme: (_productsAndFiltersFr = productsAndFiltersFromCache.currentCategory) === null || _productsAndFiltersFr === void 0 ? void 0 : _productsAndFiltersFr.theme,
              initialPrismicCategory: productsAndFiltersFromCache.prismicCategory,
              urlPrefix: urlPrefix,
              categoryId: finalCategory,
              language: language,
              requestPath: requestPath,
              pickedFilters: productsAndFiltersFromCache.pickedFilters,
              pageSize: getPageSize((_productsAndFiltersFr2 = productsAndFiltersFromCache.currentCategory) === null || _productsAndFiltersFr2 === void 0 ? void 0 : _productsAndFiltersFr2.theme),
              initialPage: isNaN(page) ? 1 : page,
              cache: cache
            });
          case 29:
            _context.next = 31;
            return categoryFetcher(finalCategory, language);
          case 31:
            _context.t1 = _yield$categoryFetche = _context.sent;
            _context.t0 = _context.t1 !== null;
            if (!_context.t0) {
              _context.next = 35;
              break;
            }
            _context.t0 = _yield$categoryFetche !== void 0;
          case 35:
            if (!_context.t0) {
              _context.next = 39;
              break;
            }
            _context.t2 = _yield$categoryFetche;
            _context.next = 40;
            break;
          case 39:
            _context.t2 = {};
          case 40:
            currentCategory = _context.t2;
            _context.next = 43;
            return Promise.all([productsAndFiltersFromCategoryFetcher(finalCategory, {}, page, getPageSize(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme), null, language), prismicFetcher("category", "category-" + finalCategory, language)]);
          case 43:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
            productsAndFilters = _yield$Promise$all2[0];
            prismicCategory = _yield$Promise$all2[1];
            if (!(Object.keys(productsAndFilters).length === 0 && productsAndFilters.constructor === Object)) {
              _context.next = 49;
              break;
            }
            return _context.abrupt("return", {
              error: {
                statusCode: 404
              }
            });
          case 49:
            availableFilters = productsAndFilters.filters === undefined ? [] : productsAndFilters.filters;
            pickedFilters = {};
            if (activeFilters) {
              _getRangeFiltersAndRe = (0, _getPickedFilters.getRangeFiltersAndRest)(availableFilters, activeFilters), queryRangeFilters = _getRangeFiltersAndRe.queryRangeFilters, queryFiltersWithRemovedRangeFiltersPart = _getRangeFiltersAndRe.queryFiltersWithRemovedRangeFiltersPart;
              pickedFilters = (0, _getPickedFilters.getPickedFiltersWithoutRangeFilters)(queryFiltersWithRemovedRangeFiltersPart, availableFilters);
              queryRangeFilters.forEach(function (filterData) {
                pickedFilters[filterData.filterName] = {};
                pickedFilters[filterData.filterName].to = filterData.max;
                pickedFilters[filterData.filterName].from = filterData.min;
                if (filterData.filterName === "capacity") {
                  pickedFilters[filterData.filterName].to *= 1000;
                  pickedFilters[filterData.filterName].from *= 1000;
                }
              });
            }
            if (sortFilter) {
              sort = sortFilter.split("&");
              sortFiltersString = "".concat((_sort$ = sort[1]) === null || _sort$ === void 0 ? void 0 : _sort$.slice(6), "-").concat((_sort$2 = sort[0]) === null || _sort$2 === void 0 ? void 0 : _sort$2.slice(4));
              if ((_sortFilter = sortFilter) !== null && _sortFilter !== void 0 && _sortFilter.includes("undefined")) {
                console.log("Problem with sort. sortFilter: ".concat(sortFilter, ", allQueryFilters: ").concat(activeFilters, " ").concat(urlAfterQuestionMark, ", requestPath: ").concat(requestPath, ", category: ").concat(finalCategory));
              }
              pickedFilters["sort"] = {
                id: sortFiltersString,
                value: sortFiltersString
              };
            }
            productsAndFiltersWithActiveFilters = productsAndFilters;
            if (!(Object.keys(pickedFilters).length > 0)) {
              _context.next = 58;
              break;
            }
            _context.next = 57;
            return productsAndFiltersFromCategoryFetcher(finalCategory, Object.keys(pickedFilters).length > 0 ? pickedFilters : {}, page, getPageSize(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme), null, language);
          case 57:
            productsAndFiltersWithActiveFilters = _context.sent;
          case 58:
            currentCategory.theme = (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme) || _categoryThemes["default"].CATEGORY;
            result = {
              initialProductsAndFilters: productsAndFiltersWithActiveFilters,
              initialCurrentCategory: currentCategory,
              categories: context.categories,
              theme: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme,
              initialPrismicCategory: prismicCategory,
              urlPrefix: urlPrefix,
              categoryId: finalCategory,
              language: language,
              requestPath: requestPath,
              pickedFilters: pickedFilters,
              pageSize: getPageSize(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme),
              initialPage: page
            };
            if (!(cacheFileExist === false)) {
              _context.next = 63;
              break;
            }
            _context.next = 63;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: filenameCategoryCache,
              result: result
            });
          case 63:
            (0, _cache.setUrlInCache)(url, _objectSpread(_objectSpread({}, productsAndFiltersWithActiveFilters), {}, {
              currentCategory: currentCategory,
              theme: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme,
              prismicCategory: prismicCategory,
              pickedFilters: pickedFilters,
              categories: context.categories
            }), cache);
            return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
              cache: cache
            }));
          case 65:
            _context.next = 71;
            break;
          case 67:
            _context.prev = 67;
            _context.t3 = _context["catch"](23);
            console.error(_context.t3);
            return _context.abrupt("return", _context.t3);
          case 71:
            return _context.abrupt("return", {});
          case 72:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[23, 67]]);
  }));
  return function categoryInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = categoryInitialProps;
exports.Z = _default;

/***/ }),

/***/ 52835:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var THEMES = {};
THEMES.CATEGORY = "default_category";
THEMES.MAIN = "main";
THEMES.COLLECTION = "collection";
THEMES.BRAND = "brand";
THEMES.BRAND_LIST = "brand_list";
THEMES.COLLECTION_LIST = "collection_list";
THEMES.INSPIRATION = "inspiration";
THEMES.INSPIRATION_LIST = "inspiration_list";
THEMES.LIST = "list";
var _default = THEMES;
exports["default"] = _default;

/***/ }),

/***/ 44306:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _replaceSpecialCharacters = _interopRequireDefault(__webpack_require__(64426));
var createFilterString = function createFilterString(filters) {
  var isPro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var filterString = "";
  var orderString = "";
  if (Object.keys(filters).length === 0) {
    return "";
  }
  if (!Array.isArray(filters)) {
    filters = [filters];
  }
  filters.forEach(function (filter) {
    if (filter.value) {
      if (filter.id === "sort") {
        var _filter$value$id$spli = filter.value.id.split("-"),
          _filter$value$id$spli2 = (0, _slicedToArray2["default"])(_filter$value$id$spli, 2),
          name = _filter$value$id$spli2[0],
          direction = _filter$value$id$spli2[1];
        orderString += "?dir=".concat(direction, "&order=").concat(name);
      } else if (filter.type === "range") {
        if (filter.id === "capacity") {
          if (!isPro) {
            filterString += "".concat(filter.id, "-").concat(filter.value.from / 1000, "-").concat(filter.value.to / 1000, "-");
            return;
          }
          filterString += "".concat(filter.id, "-").concat(filter.value.from, "-").concat(filter.value.to, "-");
        } else {
          filterString += "".concat(filter.id, "-").concat(filter.value.from, "-").concat(filter.value.to, "-");
        }
      } else {
        filterString += "".concat(filter.value.map(function (val) {
          if (!val.name) {
            var filterName = "";
            filter.items.map(function (item) {
              if (item.value_string === val.id) {
                filterName += "".concat(item.name);
              }
            });
            return filterName;
          } else {
            return val.name;
          }
        }).join("-").replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_"), "-");
      }
    }
  });
  filterString = (0, _replaceSpecialCharacters["default"])(filterString.substring(0, filterString.length - 1)).toLowerCase();
  if (filterString || orderString) {
    if (isPro) {
      filterString = filterString ? "/".concat(filterString).concat(orderString) : "".concat(orderString);
    } else {
      filterString = "/".concat(filterString).concat(orderString);
    }
  }
  return filterString.indexOf("-") === 1 ? filterString.replace("-", "") : filterString;
};
var _default = createFilterString;
exports["default"] = _default;

/***/ }),

/***/ 60461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.filtersSetValue = exports.filtersReduce = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var filtersReduce = function filtersReduce(filtersValue, pickedFiltersKeysPrev) {
  var pickedFilters = Array.isArray(filtersValue) ? filtersValue.reduce(function (pickedFilters, filter) {
    if (filter.value) {
      if (Array.isArray(filter.value) && filter.value.length < 1) {
        return pickedFilters;
      }
      if (filter.id === "capacity" && filter.isConverted) {
        filter = _objectSpread(_objectSpread({}, filter), {}, {
          isConverted: false,
          value: {
            from: filter.value.from * 1000,
            to: filter.value.to * 1000
          }
        });
      }
      pickedFilters[filter.id] = filter.value;
    }
    return pickedFilters;
  }, {}) : filtersValue;
  var pickedFiltersKeys = Object.keys(pickedFilters);
  var newlyPickedFilterKey = pickedFiltersKeys.length === 1 ? pickedFiltersKeys[0] : pickedFiltersKeys.find(function (key) {
    return pickedFiltersKeysPrev.includes(key);
  });
  return {
    pickedFilters: pickedFilters,
    pickedFiltersKeys: pickedFiltersKeys,
    newlyPickedFilterKey: newlyPickedFilterKey
  };
};
exports.filtersReduce = filtersReduce;
var filtersSetValue = function filtersSetValue(filters, filtersValue, newlyPickedFilterKey, pickedFiltersKeys) {
  filters === null || filters === void 0 ? void 0 : filters.forEach(function (filter) {
    var _filtersValue$find3;
    if (newlyPickedFilterKey === filter.id) {
      var _filtersValue$find, _filtersValue$find2;
      return pickedFiltersKeys.length === 1 ? _objectSpread(_objectSpread({}, filters.find(function (pickedFilter) {
        return pickedFilter.id === filter.id;
      })), {}, {
        value: (_filtersValue$find = filtersValue.find(function (pickedFilter) {
          return pickedFilter.id === filter.id;
        })) === null || _filtersValue$find === void 0 ? void 0 : _filtersValue$find.value
      }) : _objectSpread(_objectSpread({}, filter), {}, {
        value: (_filtersValue$find2 = filtersValue.find(function (pickedFilter) {
          return pickedFilter.id === filter.id;
        })) === null || _filtersValue$find2 === void 0 ? void 0 : _filtersValue$find2.value
      });
    }
    return _objectSpread(_objectSpread({}, filter), {}, {
      value: (_filtersValue$find3 = filtersValue.find(function (pickedFilter) {
        return pickedFilter.id === filter.id;
      })) === null || _filtersValue$find3 === void 0 ? void 0 : _filtersValue$find3.value
    });
  });
  return filters;
};
exports.filtersSetValue = filtersSetValue;

/***/ }),

/***/ 8233:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var lastNumberRegex = /\d+$/gi;
var getLastNumbersFromString = function getLastNumbersFromString(url) {
  var lastNumber = url.match(lastNumberRegex);
  return lastNumber === null || lastNumber === void 0 ? void 0 : lastNumber[0];
};
var _default = getLastNumbersFromString;
exports["default"] = _default;

/***/ }),

/***/ 21770:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getPickedFiltersWithoutRangeFilters = exports.getRangeFiltersAndRest = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _replaceSpecialCharacters = _interopRequireDefault(__webpack_require__(64426));
var _removeAdditionalParameterFromFiltersPickedFromUrl = __webpack_require__(35026);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SORT = "sort";
var RANGE = "range";
var getRangeFiltersAndRest = function getRangeFiltersAndRest(filters, queryFilters) {
  var regExp = new RegExp("(" + filters.filter(function (item) {
    return item.type === RANGE;
  }).map(function (item) {
    return item.id;
  }).join("|") + ")?-([\\.\\d]+)?-([\\.\\d]+)", "g");
  var results;
  var queryFiltersWithRemovedRangeFiltersPart = queryFilters;
  var queryRangeFilters = [];
  while ((results = regExp.exec(queryFilters)) !== null) {
    queryRangeFilters.push({
      filterName: results[1],
      min: Number(results[2]),
      max: Number(results[3])
    });
    queryFiltersWithRemovedRangeFiltersPart = queryFiltersWithRemovedRangeFiltersPart.replace(results[0], "");
  }
  return {
    queryRangeFilters: queryRangeFilters,
    queryFiltersWithRemovedRangeFiltersPart: queryFiltersWithRemovedRangeFiltersPart
  };
};
exports.getRangeFiltersAndRest = getRangeFiltersAndRest;
var getPickedFiltersWithoutRangeFilters = function getPickedFiltersWithoutRangeFilters(queryFiltersWithRemovedRangeFiltersPart, allFilters) {
  if (queryFiltersWithRemovedRangeFiltersPart === 0) return {};
  var queryFiltersWithRemovedRangeFiltersPartAndAdditionalParameter = (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(decodeURI(queryFiltersWithRemovedRangeFiltersPart));
  return queryFiltersWithRemovedRangeFiltersPartAndAdditionalParameter.split("-").reduce(function (prev, filterValue) {
    var newData = _objectSpread({}, prev);
    allFilters.some(function (filter) {
      var _filter$items, _filter$items2;
      // @TODO: temporary if
      if (filter.type === RANGE) {
        filter.max = Number(filter.max);
        filter.min = Number(filter.min);
        return false;
      }
      var filterFound = ((_filter$items = filter.items) === null || _filter$items === void 0 ? void 0 : _filter$items.find(function (item) {
        return item.name === filterValue;
      })) || ((_filter$items2 = filter.items) === null || _filter$items2 === void 0 ? void 0 : _filter$items2.find(function (item) {
        return (0, _replaceSpecialCharacters["default"])(item.name).toLowerCase().replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_") === filterValue;
      }));
      if (filterFound) {
        if (!Array.isArray(newData[filter.id])) {
          newData[filter.id] = [];
        }
        newData[filter.id] = newData[filter.id].concat(filter.items.filter(function (item) {
          return filterValue === item.name || filterValue === (0, _replaceSpecialCharacters["default"])(item.name).toLowerCase().replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_");
        }));
        return true;
      }
    });
    return newData;
  }, {});
};
exports.getPickedFiltersWithoutRangeFilters = getPickedFiltersWithoutRangeFilters;

/***/ }),

/***/ 46750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.R1 = exports.jq = exports.KT = void 0;
var _searchTree = _interopRequireDefault(__webpack_require__(50802));
var filterSubcategory = function filterSubcategory(subcategories) {
  var _subcategories$filter;
  return (_subcategories$filter = subcategories.filter(function (el) {
    return el != null && Object.keys(el).length > 0;
  })) === null || _subcategories$filter === void 0 ? void 0 : _subcategories$filter[0];
};
var getSubcategories = function getSubcategories(categories, currentCategory, getRoute, router) {
  var _filterSubcategory;
  return categories && currentCategory && ((_filterSubcategory = filterSubcategory(categories.map(function (category) {
    return (0, _searchTree["default"])(category, currentCategory.id);
  }))) === null || _filterSubcategory === void 0 ? void 0 : _filterSubcategory.subcategories.map(function (subcategory) {
    return {
      url: subcategory.url,
      label: subcategory === null || subcategory === void 0 ? void 0 : subcategory.name,
      additionalLabel: false,
      onCategoryClick: function onCategoryClick() {
        return router && getRoute && router.push(getRoute("category-page", subcategory).href, subcategory.url.indexOf("/") === 0 ? subcategory.url : "/" + subcategory.url);
      }
    };
  }));
};
exports.KT = getSubcategories;
var getSubcategoriesForLeftColumn = function getSubcategoriesForLeftColumn(categories, currentCategory) {
  var _filterSubcategory2;
  return categories && ((_filterSubcategory2 = filterSubcategory(categories.map(function (category) {
    return (0, _searchTree["default"])(category, currentCategory.level > 4 ? currentCategory.parentId : currentCategory.id);
  }))) === null || _filterSubcategory2 === void 0 ? void 0 : _filterSubcategory2.subcategories);
};
exports.jq = getSubcategoriesForLeftColumn;
var getParentCategory = function getParentCategory(categories, currentCategory) {
  return filterSubcategory(categories.map(function (category) {
    return (0, _searchTree["default"])(category, currentCategory.parentId);
  }));
};
exports.R1 = getParentCategory;

/***/ }),

/***/ 97831:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var moveOutOfStockProductsLast = function moveOutOfStockProductsLast(mappedProducts) {
  var outOfStockProducts = [];
  var inStockProducts = [];
  mappedProducts.forEach(function (product) {
    if (product.availability.level === "270") {
      outOfStockProducts.push(product);
    } else {
      inStockProducts.push(product);
    }
  });
  return [].concat(inStockProducts, outOfStockProducts);
};
var _default = moveOutOfStockProductsLast;
exports["default"] = _default;

/***/ }),

/***/ 35026:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.removeAdditionalParameterFromFiltersString = exports.removeAdditionalParameterFromFiltersPickedFromUrl = exports["default"] = void 0;
var parametersList = ["fbclid"];
var removeAdditionalParameterFromFiltersPickedFromUrl = function removeAdditionalParameterFromFiltersPickedFromUrl(pickedFilters) {
  pickedFilters.map(function (filter, index) {
    if (parametersList.find(function (parameter) {
      return parameter === filter;
    })) {
      pickedFilters.splice(index, 1);
    }
  });
  return pickedFilters;
};
exports.removeAdditionalParameterFromFiltersPickedFromUrl = removeAdditionalParameterFromFiltersPickedFromUrl;
var removeAdditionalParameterFromFiltersString = function removeAdditionalParameterFromFiltersString(filtersString) {
  // here I assume the additional parameter is always at the end of this string
  var chars = ["&", "?"];
  var correctedFiltersString = filtersString;
  parametersList.find(function (parameter) {
    var _char = chars.find(function (_char2) {
      return filtersString.indexOf("".concat(_char2).concat(parameter)) > -1;
    });
    if (_char) {
      var filtersStringArray = filtersString.split("".concat(_char).concat(parameter));
      correctedFiltersString = filtersStringArray[0];
    }
  });
  return correctedFiltersString;
};
exports.removeAdditionalParameterFromFiltersString = removeAdditionalParameterFromFiltersString;
var _default = removeAdditionalParameterFromFiltersPickedFromUrl; // function used to remove parameters added to url by Facebook
// later possibly also other analytic/marketing parameters
// removeAdditionalParameterFromFiltersPickedFromUrl
// needed because: these parameters cause filters to return empty result
// as the parameter is used as filter
// removeAdditionalParameterFromFiltersString
// needed because: last filter is removed when the parameter is added
exports["default"] = _default;

/***/ }),

/***/ 6074:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var slashRegex = new RegExp(/^\//);
var removeSlash = function removeSlash(url) {
  return url && url.replace(slashRegex, "");
};
var _default = removeSlash;
exports["default"] = _default;

/***/ }),

/***/ 60926:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.separateFiltersAndSortFromUrlPro = void 0;
var separateFiltersAndSortFromUrl = function separateFiltersAndSortFromUrl(activeFiltersString, url) {
  var _ref;
  var urlAfterQuestionMark;
  url = (_ref = activeFiltersString || url) === null || _ref === void 0 ? void 0 : _ref.replace(/\?.*/g, function (urlWithQuestionMark) {
    urlAfterQuestionMark = urlWithQuestionMark.substring(1);
    return "";
  });
  return {
    urlAfterQuestionMark: urlAfterQuestionMark,
    activeFilters: activeFiltersString ? url : ""
  };
};
var separateFiltersAndSortFromUrlPro = function separateFiltersAndSortFromUrlPro(activeFiltersString, url) {
  var _url;
  var urlAfterQuestionMark;
  url = (_url = url) === null || _url === void 0 ? void 0 : _url.replace(/\?.*/g, function (urlWithQuestionMark) {
    urlAfterQuestionMark = urlWithQuestionMark.substring(1);
    return "";
  });
  return {
    urlAfterQuestionMark: urlAfterQuestionMark,
    activeFilters: activeFiltersString
  };
};
exports.separateFiltersAndSortFromUrlPro = separateFiltersAndSortFromUrlPro;
var _default = separateFiltersAndSortFromUrl;
exports["default"] = _default;

/***/ }),

/***/ 86144:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _RouteContext = __webpack_require__(73157);
var _ScrollableStack = _interopRequireDefault(__webpack_require__(50902));
var _useWindowSize = _interopRequireDefault(__webpack_require__(47272));
var _Category = _interopRequireDefault(__webpack_require__(54801));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CategoriesTagsSlider = function CategoriesTagsSlider(_ref) {
  var categories = _ref.categories,
    button = _ref.button;
  var tagButton = function tagButton(label) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: {
        $outline: true,
        $size: "small",
        $rounded: true,
        $selectable: true,
        mx: "s3",
        mb: "s4",
        width: ["40vw", "130px", "150px", "auto"],
        maxWidth: ["40vw", "130px", "150px", "unset"],
        "&:hover": {
          borderColor: "main"
        }
      }
    }, label);
  };
  var size = (0, _useWindowSize["default"])();
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var containerStyles = {
    width: "100%",
    maxWidth: "100%",
    my: "s10",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
  if (size.width <= 960) return __jsx(_ScrollableStack["default"], {
    sx: _objectSpread(_objectSpread({}, containerStyles), {}, {
      $itemsVisible: [2.1, 3.5, 4.1, null],
      $gap: 4
    })
  }, categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
    return __jsx(Link, {
      route: "category-page",
      params: category
    }, tagButton(category.name));
  }));else return __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, containerStyles), {}, {
      flexWrap: "wrap"
    })
  }, categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
    return __jsx(Link, {
      route: "category-page",
      params: category
    }, tagButton(category.name));
  }));
};
var _default = CategoriesTagsSlider;
exports.Z = _default;

/***/ }),

/***/ 87627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _MenuItemButton = _interopRequireDefault(__webpack_require__(81023));
var _LabelWithImage = __webpack_require__(44325);
var __jsx = _react["default"].createElement;
var MenuItemsList = function MenuItemsList(props) {
  var title = props.title,
    menuItems = props.menuItems;
  return __jsx(_Box["default"], null, title && __jsx(_Box["default"], {
    as: "h1",
    sx: {
      color: "main",
      textAlign: "center",
      my: "s9",
      pb: "s8",
      font: "heading2"
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, menuItems.map(function (menuItem, index) {
    return __jsx(_Box["default"], {
      sx: {
        height: "52px"
      },
      key: index
    }, __jsx(_MenuItemButton["default"], {
      sx: {
        border: "0px",
        borderBottomWidth: "1px",
        cursor: "pointer",
        background: "transparent",
        borderStyle: "solid",
        borderColor: "neutral",
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%"
      },
      label: menuItem.label,
      url: menuItem.url,
      onClick: menuItem.onCategoryClick,
      additionalLabel: menuItem.additionalLabel,
      image: null,
      button: "true",
      labelMode: _LabelWithImage.LABEL_MODE.labelRight
    }));
  })));
};
var _default = MenuItemsList;
exports.Z = _default;

/***/ }),

/***/ 26034:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var __jsx = _react["default"].createElement;
var RectangleCardWithLabelInsideSection = function RectangleCardWithLabelInsideSection(_ref) {
  var rectangleCards = _ref.rectangleCards;
  return __jsx(_Grid["default"], {
    cols: [2, null, 4, null]
  }, rectangleCards.map(function (rectangleCard, index) {
    return __jsx(_Box["default"], {
      key: index
    }, rectangleCard);
  }));
};
var _default = RectangleCardWithLabelInsideSection;
exports.Z = _default;

/***/ }),

/***/ 44102:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _SquareCardWithLabel = _interopRequireDefault(__webpack_require__(17951));
var __jsx = _react["default"].createElement;
function SquareCardWithLabelSection(props) {
  var productTypes = props.productTypes;
  return __jsx(_Grid["default"], {
    cols: [3, null, 5, null]
  }, productTypes.map(function (item, index) {
    return __jsx(_SquareCardWithLabel["default"], {
      productData: item,
      key: index
    });
  }));
}
var _default = SquareCardWithLabelSection;
exports.Z = _default;

/***/ }),

/***/ 46541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_CollectionCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31265);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CollectionCard = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_CollectionCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionCard);


/***/ }),

/***/ 77501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_CollectionDetails__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99240);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CollectionDetails = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_CollectionDetails__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionDetails);


/***/ }),

/***/ 91993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_InfluencerBio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11316);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InfluencerBio = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_InfluencerBio__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (InfluencerBio);


/***/ }),

/***/ 82348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_InspirationHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71745);
/* harmony import */ var _deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51586);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InspirationHeader = function(props) {
    var propsExt = _objectSpread({}, props, {
        button: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
            sx: {
                $outline: true
            }
        })
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_InspirationHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["Z"] = (InspirationHeader);


/***/ }),

/***/ 14742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94986);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(53746);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Box/index.js
var Box = __webpack_require__(40300);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/useWindowSize.js
var useWindowSize = __webpack_require__(47272);
var useWindowSize_default = /*#__PURE__*/__webpack_require__.n(useWindowSize);
// EXTERNAL MODULE: ./src/globals.js
var globals = __webpack_require__(88084);
// EXTERNAL MODULE: ./src/theme.js
var src_theme = __webpack_require__(42223);
;// CONCATENATED MODULE: ./conf/disabledFilters.json
var disabledFilters_namespaceObject = ["price"];
// EXTERNAL MODULE: ../helpers/dist/langLibrary/index.js
var langLibrary = __webpack_require__(51493);
// EXTERNAL MODULE: ../helpers/dist/categoryInitialProps/index.js
var categoryInitialProps = __webpack_require__(7121);
// EXTERNAL MODULE: ../helpers/dist/categoryThemes/index.js
var categoryThemes = __webpack_require__(52835);
// EXTERNAL MODULE: ../helpers/dist/getSubcategories/index.js
var getSubcategories = __webpack_require__(46750);
// EXTERNAL MODULE: ./src/components/MetaTags/index.js + 1 modules
var MetaTags = __webpack_require__(39125);
// EXTERNAL MODULE: ../components-new/dist/CategoriesSliderMobile/index.js
var CategoriesSliderMobile = __webpack_require__(47516);
;// CONCATENATED MODULE: ./src/components/CategoriesSliderMobile/index.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CategoriesSliderMobile_CategoriesSliderMobile = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CategoriesSliderMobile/* default */.Z, _objectSpread({}, props));
};
/* harmony default export */ var components_CategoriesSliderMobile = (CategoriesSliderMobile_CategoriesSliderMobile);

// EXTERNAL MODULE: ./src/components/Pagination/index.js
var Pagination = __webpack_require__(62067);
// EXTERNAL MODULE: ./src/components/FiltersBarDesktop/index.js
var FiltersBarDesktop = __webpack_require__(17930);
// EXTERNAL MODULE: ./src/components/FiltersBarMobile/index.js
var FiltersBarMobile = __webpack_require__(34801);
// EXTERNAL MODULE: ./src/pages/c/brand.js
var brand = __webpack_require__(9757);
// EXTERNAL MODULE: ./src/pages/c/brands-list.js
var brands_list = __webpack_require__(91328);
// EXTERNAL MODULE: ./src/pages/c/collections-list.js
var collections_list = __webpack_require__(88697);
// EXTERNAL MODULE: ./src/pages/c/collection.js + 3 modules
var collection = __webpack_require__(4284);
// EXTERNAL MODULE: ./src/pages/c/inspiration.js
var inspiration = __webpack_require__(65225);
// EXTERNAL MODULE: ./src/pages/c/category.js
var category = __webpack_require__(84749);
// EXTERNAL MODULE: ./src/pages/c/inspirations-list.js + 1 modules
var inspirations_list = __webpack_require__(10753);
// EXTERNAL MODULE: ./src/getRoute.js
var getRoute = __webpack_require__(79363);
// EXTERNAL MODULE: ../API/dist/hooks/common/useNormalizeAndMapFilters/index.js
var useNormalizeAndMapFilters = __webpack_require__(68885);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useFilters.js
var useFilters = __webpack_require__(93721);
// EXTERNAL MODULE: ../API/dist/hooks/common/usePaginationLoader.js
var usePaginationLoader = __webpack_require__(95514);
// EXTERNAL MODULE: ../API/dist/hooks/common/useLoader.js
var useLoader = __webpack_require__(87573);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useProductsAndFiltersFromCategory/index.js
var useProductsAndFiltersFromCategory = __webpack_require__(42807);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useCategory/index.js
var useCategory = __webpack_require__(99906);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismic/index.js
var usePrismic = __webpack_require__(22686);
;// CONCATENATED MODULE: ./src/pages/c/[...category].js

































function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var CategoryPage = function(props) {
    var ref13;
    var initialCurrentCategory = props.initialCurrentCategory, categories = props.categories, initialPrismicCategory = props.initialPrismicCategory, language = props.language, categoryBanners = props.categoryBanners, categoryId = props.categoryId, requestPath = props.requestPath, pageSize = props.pageSize, theme = props.theme, cache = props.cache;
    var pickedFilters = props.pickedFilters, initialProductsAndFilters = props.initialProductsAndFilters;
    var router = (0,next_router.useRouter)();
    var ref1;
    var initialPage = (ref1 = (ref13 = router.asPath.match(/p=([0-9]*)/)) === null || ref13 === void 0 ? void 0 : ref13[1]) !== null && ref1 !== void 0 ? ref1 : 1;
    var ref2 = (0,usePaginationLoader.usePaginationLoader)(), isLoading = ref2.isLoading, setPaginationLoadingState = ref2.setPaginationLoadingState;
    var firstUpdate = (0,react.useRef)(true);
    var size = useWindowSize_default()();
    var isMobile = size.width <= parseInt((0,src_theme/* default */.Z)().breakpoints.md);
    var externalContentTimeout = (0,useLoader.useLoader)().externalContentTimeout;
    var ref3 = (0,react.useState)(false), filtersReady = ref3[0], setFiltersReady = ref3[1];
    (0,react.useEffect)(function() {
        if (filtersReady) {
            return;
        }
        if (isMobile !== null) {
            setFiltersReady(true);
        }
    }, [
        isMobile
    ]);
    var ref4 = (0,useProductsAndFiltersFromCategory.useProductsAndFiltersFromCategory)(categoryId, pickedFilters, initialPage, pageSize, null, language, initialProductsAndFilters, router, cache), _data = ref4.data, _products = _data.products, products = _products === void 0 ? [] : _products, productsTotalCount = _data.productsTotalCount, filters1 = _data.filters, narrowedFilters = _data.narrowedFilters;
    var ref5 = (0,useFilters/* default */.Z)(products, categoryId, narrowedFilters, initialPage, filters1, router, pageSize, firstUpdate.current === true, cache, disabledFilters_namespaceObject), categoryProducts = ref5.products, page = ref5.page, activeFilters = ref5.activeFilters, onFiltersChange = ref5.onFiltersChange;
    var ref6 = (0,useNormalizeAndMapFilters["default"])({
        data: activeFilters
    }), filtersData = ref6.filters;
    var ref7 = (0,useCategory/* useCategory */.b5)(categoryId, initialCurrentCategory), tmp = ref7.data, currentCategory = tmp === void 0 ? {} : tmp;
    currentCategory.name = (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name) || "";
    var ref8 = (0,usePrismic/* usePrismic */.xD)("category", "category-" + categoryId, language, initialPrismicCategory), prismicCategory = ref8.data;
    var translations = {
        seoDescription: (0,langLibrary["default"])("Meta description", {
            categoryName: currentCategory.name
        }),
        seoTitle: "".concat(currentCategory.name, " | Dajar "),
        home: (0,langLibrary["default"])("Home")
    };
    var scrollToRef = (0,react.useRef)();
    var onPageChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(pageToSet) {
            var ref, ref12, asPath, urlPath, pathAlreadyContainsQuestionMark, scrollTop, currentPosition, pageStringToSet;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!isLoading) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setPaginationLoadingState(true);
                        asPath = router.asPath;
                        urlPath = asPath.indexOf("?p=") >= 0 ? asPath.split("?p=") : asPath.split("&p=");
                        pathAlreadyContainsQuestionMark = ((ref = urlPath[0]) === null || ref === void 0 ? void 0 : ref.indexOf("?")) >= 0;
                        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        currentPosition = (ref12 = scrollToRef.current) === null || ref12 === void 0 ? void 0 : ref12.getBoundingClientRect();
                        currentPosition ? window.scrollTo(0, currentPosition.top + scrollTop - 150) : window.scrollTo(0, 0);
                        pageStringToSet = pathAlreadyContainsQuestionMark ? "&p=".concat(pageToSet) : "?p=".concat(pageToSet);
                        _ctx.next = 13;
                        return onFiltersChange(activeFilters, pageToSet, requestPath, categories, currentCategory, prismicCategory);
                    case 13:
                        router.push("/[...categoryOrProductPage]", "".concat(urlPath[0]).concat(pageStringToSet), {
                            shallow: true
                        }).then(function() {
                            return window.scrollTo(0, currentPosition);
                        }).then(function() {
                            return setPaginationLoadingState(false);
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onPageChange(pageToSet) {
            return _ref.apply(this, arguments);
        };
    }();
    var pagesAmount = Math.ceil(productsTotalCount / pageSize);
    var categorySubcategories = (0,getSubcategories/* getSubcategories */.KT)(categories, currentCategory, getRoute/* default */.Z, router);
    var subcategoryForLeftColumn = (0,getSubcategories/* getSubcategoriesForLeftColumn */.jq)(categories, currentCategory);
    var parentCategory = (0,getSubcategories/* getParentCategory */.R1)(categories, currentCategory);
    var backLabel = currentCategory.level > 3 ? parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name : translations.home;
    var backClickFunction = function() {
        currentCategory.level > 3 ? router.push((0,getRoute/* default */.Z)("category-page", parentCategory).href, "/" + parentCategory.url) : router.push((0,getRoute/* default */.Z)("home-page").href, "/");
    };
    var changeUrlAfterFiltering = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(filters) {
            var filtersString;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return onFiltersChange(filters, 1, requestPath, categories, currentCategory, prismicCategory);
                    case 2:
                        filtersString = _ctx.sent;
                        router.push("/[...categoryOrProductPage]", "/".concat(requestPath).concat(filtersString), {
                            shallow: true
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeUrlAfterFiltering(filters) {
            return _ref.apply(this, arguments);
        };
    }();
    var isDialogMobileOpen = (0,react.useRef)(false);
    var filtersBar = filtersReady && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
        ref: scrollToRef,
        children: isMobile || isDialogMobileOpen.current ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBarMobile/* default */.Z, {
            data: activeFilters,
            onChange: changeUrlAfterFiltering,
            isDialogMobileOpen: isDialogMobileOpen
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBarDesktop/* default */.Z, {
            data: activeFilters,
            onChange: changeUrlAfterFiltering
        })
    });
    var categoriesSliderMobile = isMobile !== null && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CategoriesSliderMobile, {
        categories: subcategoryForLeftColumn
    });
    var pagination = /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
        pagesAmount: pagesAmount,
        currentPage: page !== null && page !== void 0 ? page : 1,
        onChange: onPageChange
    });
    var categoryBanner = categoryBanners && !externalContentTimeout && categoryBanners.find(function(banner) {
        if (banner.categoryId === parseInt(categoryId)) {
            return banner;
        }
    });
    var chosenFiltersValues = "";
    var collectionFromFilters;
    var noFollow = false;
    var collectionFromFiltersString = "";
    if (activeFilters) {
        try {
            var ref9;
            chosenFiltersValues = activeFilters.filter(function(filter) {
                return ![
                    "range",
                    "select"
                ].includes(filter.type) && filter.value;
            }).map(function(filter) {
                return Array.isArray(filter.value) && filter.value.map(function(value) {
                    return value.name;
                });
            }).flat();
            collectionFromFilters = activeFilters.filter(function(filter) {
                return ![
                    "range",
                    "select"
                ].includes(filter.type) && filter.value && filter.id === "dajar_collection";
            }).map(function(filter) {
                return filter.value.map(function(value) {
                    return value.name;
                });
            }).flat();
            (collectionFromFilters === null || collectionFromFilters === void 0 ? void 0 : collectionFromFilters.length) > 0 && collectionFromFilters.map(function(filter) {
                return collectionFromFiltersString += filter + ", ";
            });
            collectionFromFiltersString = collectionFromFiltersString.substring(0, collectionFromFiltersString.length - 2);
            noFollow = activeFilters.filter(function(filter) {
                return filter.value;
            }).map(function(filter) {
                return Array.isArray(filter.value) ? filter.value.map(function(value) {
                    return value.name;
                }) : filter.value.id;
            }).flat().length > 2 || activeFilters.find(function(filter) {
                return Array.isArray(filter.value) && filter.value.length > 1;
            }) || activeFilters.length === 1 && activeFilters[0].id === "sort" || ((ref9 = activeFilters.find(function(filter) {
                return filter.id === "sort";
            })) === null || ref9 === void 0 ? void 0 : ref9.value) || activeFilters.find(function(filter) {
                return filter.type === "range" && filter.value;
            });
        } catch (e) {
            console.error("Filters category", activeFilters, e, initialCurrentCategory, categoryId, language);
        }
    }
    var renderWithMetaTags = function(Component) {
        var ref, ref14, ref15, ref16;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                    page: MetaTags/* default.CATEGORY_PAGE */.Z.CATEGORY_PAGE,
                    description: ((ref = currentCategory.meta) === null || ref === void 0 ? void 0 : ref.description) ? (ref14 = currentCategory.meta) === null || ref14 === void 0 ? void 0 : ref14.description : translations.seoDescription,
                    title: ((ref15 = currentCategory.meta) === null || ref15 === void 0 ? void 0 : ref15.title) ? currentCategory.meta.title : translations.seoTitle,
                    currentPageNumber: page > 1 ? page : 0,
                    imageUrl: (ref16 = categoryProducts[0]) === null || ref16 === void 0 ? void 0 : ref16.image.originalSrc,
                    tags: chosenFiltersValues,
                    url: currentCategory.url,
                    noFollow: noFollow
                }),
                Component
            ]
        }));
    };
    switch(theme){
        case categoryThemes["default"].CATEGORY:
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(category["default"], {
                currentCategory: currentCategory,
                parentCategory: {
                    name: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name,
                    url: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.url
                },
                categoryProducts: categoryProducts,
                filtersBar: filtersBar,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent,
                pagination: pagination,
                dataRequiredToHideLoader: [
                    categories,
                    prismicCategory
                ],
                prismicData: prismicCategory,
                categoryBanner: categoryBanner,
                filtersString: chosenFiltersValues.length ? chosenFiltersValues.length > 3 ? chosenFiltersValues.slice().splice(0, 3).join(", ") + "... - " : chosenFiltersValues.join(", ") + " - " : "",
                totalCount: productsTotalCount
            }, categoryId));
        case categoryThemes["default"].MAIN:
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(category["default"], {
                subcategoryForLeftColumn: subcategoryForLeftColumn,
                currentCategory: currentCategory,
                parentCategory: {
                    name: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name,
                    url: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.url
                },
                categoryProducts: categoryProducts,
                filtersBar: filtersBar,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent,
                pagination: pagination,
                categoriesSliderMobile: categoriesSliderMobile,
                dataRequiredToHideLoader: [
                    categories,
                    prismicCategory
                ],
                prismicData: prismicCategory,
                isDefaultView: false,
                categoryBanner: categoryBanner,
                filtersString: chosenFiltersValues.length ? chosenFiltersValues.length > 3 ? chosenFiltersValues.slice().splice(0, 3).join(", ") + "... - " : chosenFiltersValues.join(", ") + " - " : "",
                totalCount: productsTotalCount
            }, categoryId));
        case categoryThemes["default"].COLLECTION:
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(collection["default"], {
                prismicData: prismicCategory,
                currentCategory: currentCategory,
                parentCategory: {
                    name: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name,
                    url: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.url
                },
                categoryProducts: categoryProducts && categoryProducts,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent,
                dataRequiredToHideLoader: [
                    prismicCategory,
                    categoryProducts
                ],
                pagination: pagination,
                addToCartDisabled: language.language === __webpack_require__.g.__appConfig__.shopOffGB,
                totalCount: productsTotalCount
            }, categoryId));
        case categoryThemes["default"].COLLECTION_LIST:
            var ref10;
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(collections_list["default"], {
                collectionCategoryName: currentCategory && currentCategory.name,
                onFiltersChange: onFiltersChange,
                filters: filters1,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent,
                collections: prismicCategory === null || prismicCategory === void 0 ? void 0 : (ref10 = prismicCategory.content) === null || ref10 === void 0 ? void 0 : ref10.collections
            }, categoryId));
        case categoryThemes["default"].BRAND:
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(brand["default"], {
                allCollectionProducts: categoryProducts && categoryProducts,
                brandName: currentCategory && currentCategory.name,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent,
                pagination: pagination,
                filtersBar: filtersBar,
                dataRequiredToHideLoader: [
                    categoryProducts
                ],
                prismicData: prismicCategory,
                collectionFromFiltersString: collectionFromFiltersString,
                totalCount: productsTotalCount
            }, categoryId));
        case categoryThemes["default"].BRAND_LIST:
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(brands_list["default"], {
                title: currentCategory && currentCategory.name,
                menuItems: categorySubcategories && categorySubcategories,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent
            }, categoryId));
        case categoryThemes["default"].INSPIRATION_LIST:
            var ref11;
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(inspirations_list["default"], {
                categoryName: currentCategory && currentCategory.name,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                inspirations: prismicCategory === null || prismicCategory === void 0 ? void 0 : (ref11 = prismicCategory.content) === null || ref11 === void 0 ? void 0 : ref11.inspirations,
                subcategories: subcategoryForLeftColumn,
                footerContent: props.footerContent
            }, categoryId));
        case categoryThemes["default"].INSPIRATION:
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(inspiration["default"], {
                prismicData: prismicCategory,
                categoryProducts: categoryProducts && categoryProducts,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent,
                dataRequiredToHideLoader: [
                    categoryProducts
                ],
                addToCartDisabled: language.language === __webpack_require__.g.__appConfig__.shopOffGB
            }, categoryId));
        default:
            return renderWithMetaTags(/*#__PURE__*/ (0,jsx_runtime.jsx)(category["default"], {
                currentCategory: currentCategory,
                parentCategory: {
                    name: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name,
                    url: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.url
                },
                categoryProducts: categoryProducts,
                filtersBar: filtersBar,
                backLabel: backLabel,
                backClickFunction: backClickFunction,
                footerContent: props.footerContent,
                pagination: pagination,
                dataRequiredToHideLoader: [
                    categories,
                    prismicCategory
                ],
                prismicData: prismicCategory,
                categoryBanner: categoryBanner,
                totalCount: productsTotalCount
            }, categoryId));
    }
};
CategoryPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(context) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,categoryInitialProps/* default */.Z)({
                        context: context,
                        productsAndFiltersFromCategoryFetcher: useProductsAndFiltersFromCategory.fetcher,
                        categoryFetcher: useCategory/* fetcher */._i,
                        prismicFetcher: usePrismic/* fetcher */._i
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ var _category_ = (CategoryPage);


/***/ }),

/***/ 9757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51493);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34885);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98290);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73764);
/* harmony import */ var _sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44553);
/* harmony import */ var _components_ProductBox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87122);
/* harmony import */ var _sections_RectangleCardWithLabelInsideSection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94918);
/* harmony import */ var _sections_SquareCardWithLabelSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49308);
/* harmony import */ var _components_RectangleCardWithLabelBoxInside__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62999);
/* harmony import */ var _components_CollectionDetails__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77501);
/* harmony import */ var _deosite_components_new_Image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90451);
/* harmony import */ var _deosite_api_hooks_common_useAnalytics4AndCommerceTags__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79892);















var BrandPage = function(param) {
    var allCollectionProducts = param.allCollectionProducts, brandName = param.brandName, footerContent = param.footerContent, pagination = param.pagination, filtersBar = param.filtersBar, dataRequiredToHideLoader = param.dataRequiredToHideLoader, prismicData = param.prismicData, backLabel = param.backLabel, backClickFunction = param.backClickFunction, collectionFromFiltersString = param.collectionFromFiltersString, _totalCount = param.totalCount, totalCount = _totalCount === void 0 ? "" : _totalCount;
    var ref, ref1, ref2, ref3, ref4;
    var translations = {
        seeAll: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("see all"),
        popularCategories: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Popular categories"),
        newIn: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("New in"),
        allNew: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("all new"),
        bestsellers: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Bestsellers"),
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Default seo title"),
        shopByCollection: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Shop by Collection"),
        shopByType: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Shop by Type")
    };
    var viewList = (0,_deosite_api_hooks_common_useAnalytics4AndCommerceTags__WEBPACK_IMPORTED_MODULE_14__["default"])().viewList;
    var isFirstRun = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            viewList(allCollectionProducts, collectionFromFiltersString !== null && collectionFromFiltersString !== void 0 ? collectionFromFiltersString : brandName);
        }
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        footerContent: footerContent,
        returnLinkLabel: backLabel,
        onReturnLabelClick: backClickFunction,
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        dataRequiredToHideLoader: dataRequiredToHideLoader,
        children: [
            ((ref = prismicData.content) === null || ref === void 0 ? void 0 : (ref1 = ref.logo) === null || ref1 === void 0 ? void 0 : ref1.originalSrc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                sx: {
                    mt: "s10"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default()), {
                        cols: [
                            1,
                            null,
                            20,
                            null
                        ],
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                            sx: {
                                textAlign: "center",
                                gridColumn: [
                                    "span 1",
                                    null,
                                    "8 / span 6",
                                    null
                                ]
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_Image__WEBPACK_IMPORTED_MODULE_13__["default"], {
                                sx: {
                                    objectFit: "contain",
                                    maxHeight: "200px"
                                },
                                image: prismicData.content.logo
                            })
                        })
                    })
                })
            }),
            (prismicData === null || prismicData === void 0 ? void 0 : (ref2 = prismicData.content) === null || ref2 === void 0 ? void 0 : ref2.tiles) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                title: translations.shopByCollection,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_RectangleCardWithLabelInsideSection__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        rectangleCards: prismicData.content.tiles.map(function(collectionTile) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RectangleCardWithLabelBoxInside__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                link: collectionTile.url,
                                label: collectionTile.title,
                                image: collectionTile.image,
                                promoLabel: collectionTile.promoLabel
                            });
                        })
                    })
                })
            }),
            (prismicData === null || prismicData === void 0 ? void 0 : (ref3 = prismicData.content) === null || ref3 === void 0 ? void 0 : ref3.types) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                title: translations.shopByType,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SquareCardWithLabelSection__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        productTypes: prismicData.content.types
                    })
                })
            }),
            (prismicData === null || prismicData === void 0 ? void 0 : (ref4 = prismicData.content) === null || ref4 === void 0 ? void 0 : ref4.description) && pagination.props.currentPage === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                        sx: {
                            borderBottomWidth: [
                                "1px",
                                null,
                                "0px",
                                null
                            ],
                            borderTopWidth: [
                                "1px",
                                null,
                                "0px",
                                null
                            ],
                            borderStyle: "solid",
                            borderColor: "neutral"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default()), {
                            cols: [
                                1,
                                null,
                                20,
                                null
                            ],
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                                sx: {
                                    gridColumn: [
                                        "span 1",
                                        null,
                                        "6 / span 10",
                                        null
                                    ]
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CollectionDetails__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    collection: prismicData.content.description
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                titleAs: "h1",
                title: collectionFromFiltersString ? "".concat(collectionFromFiltersString, " - ").concat(brandName, " (").concat(totalCount, ")") : "".concat(brandName, " (").concat(totalCount, ")"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                            sx: {
                                width: "100%"
                            },
                            children: filtersBar
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default()), {
                            cols: [
                                2,
                                null,
                                4,
                                null
                            ],
                            children: allCollectionProducts.map(function(product, index) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductBox__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    product: product,
                                    colors: []
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                            sx: {
                                marginTop: "s12"
                            },
                            children: pagination
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (BrandPage);


/***/ }),

/***/ 91328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51493);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34885);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _sections_MenuItemsList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31305);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73764);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98290);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44553);









var BrandsListPage = function(param) {
    var title = param.title, menuItems = param.menuItems, backLabel = param.backLabel, backClickFunction = param.backClickFunction, footerContent = param.footerContent, dataRequiredToHideLoader = param.dataRequiredToHideLoader;
    var translations = {
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Default seo title")
    };
    var splitBrandsMenu = function() {
        var splitMenu = [];
        var element;
        var arrayLength = (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) || 0;
        var partSize = 10;
        for(element = 0, arrayLength; element < arrayLength; element += partSize){
            var arrayPart = menuItems.slice(element, element + partSize);
            splitMenu.push(arrayPart);
        }
        return splitMenu;
    };
    var brandsMenu = menuItems ? splitBrandsMenu() : false;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        footerContent: footerContent,
        returnLinkLabel: backLabel,
        onReturnLabelClick: backClickFunction,
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        dataRequiredToHideLoader: dataRequiredToHideLoader,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            title: title,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_7___default()), {
                    cols: [
                        1,
                        null,
                        null,
                        20
                    ],
                    children: Array.isArray(brandsMenu) && (brandsMenu === null || brandsMenu === void 0 ? void 0 : brandsMenu.map(function(menu, index) {
                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                            sx: {
                                gridColumn: [
                                    "span 1",
                                    null,
                                    "span 5",
                                    null
                                ],
                                mt: index > 0 ? [
                                    "-9px",
                                    null,
                                    0,
                                    null
                                ] : 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_MenuItemsList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                menuItems: menu
                            })
                        }, index));
                    }))
                })
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (BrandsListPage);


/***/ }),

/***/ 88697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51493);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98290);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73764);
/* harmony import */ var _components_CollectionCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46541);
/* harmony import */ var _sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44553);









var CollectionsListPage = function(props) {
    var collectionCategoryName = props.collectionCategoryName, backLabel = props.backLabel, backClickFunction = props.backClickFunction, footerContent = props.footerContent, dataRequiredToHideLoader = props.dataRequiredToHideLoader, collections = props.collections;
    var translations = {
        collections: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Collections"),
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Default seo title")
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        footerContent: footerContent,
        returnLinkLabel: backLabel,
        onReturnLabelClick: backClickFunction,
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        dataRequiredToHideLoader: dataRequiredToHideLoader,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            title: collectionCategoryName,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: collections && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4___default()), {
                    cols: 20,
                    children: collections.map(function(collection, index) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                            sx: {
                                marginBottom: "s11",
                                gridColumn: [
                                    "span 20",
                                    null,
                                    "4 / span 14",
                                    null
                                ]
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CollectionCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                collection: collection
                            })
                        }, index);
                    })
                })
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (CollectionsListPage);


/***/ }),

/***/ 65225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51493);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98290);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _deosite_components_new_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90451);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73764);
/* harmony import */ var _components_InspirationHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82348);
/* harmony import */ var _components_InfluencerBio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91993);
/* harmony import */ var _components_MinifiedProductPanel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35660);
/* harmony import */ var _components_InspirationCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15845);
/* harmony import */ var _sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44553);
/* harmony import */ var _sections_Grid2Cards__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90485);














var InspirationPage = function(props) {
    var ref, ref1, ref2, ref3;
    var categoryProducts = props.categoryProducts, backLabel = props.backLabel, backClickFunction = props.backClickFunction, footerContent = props.footerContent, dataRequiredToHideLoader = props.dataRequiredToHideLoader, prismicData = props.prismicData, addToCartDisabled = props.addToCartDisabled;
    var translations = {
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("Default seo title"),
        peopleLiked: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_2__["default"])("People also liked")
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        footerContent: footerContent,
        returnLinkLabel: backLabel,
        onReturnLabelClick: backClickFunction,
        minifiedMargin: true,
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        dataRequiredToHideLoader: dataRequiredToHideLoader,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4___default()), {
                    cols: [
                        1,
                        1,
                        20,
                        20,
                        20
                    ],
                    children: [
                        (prismicData === null || prismicData === void 0 ? void 0 : (ref = prismicData.content) === null || ref === void 0 ? void 0 : ref.inspirationPage) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                            sx: {
                                gridColumn: [
                                    "span 2",
                                    null,
                                    "span 9",
                                    null
                                ]
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    sx: {
                                        display: [
                                            "block",
                                            null,
                                            null,
                                            "none"
                                        ],
                                        mb: "s10"
                                    },
                                    children: (prismicData === null || prismicData === void 0 ? void 0 : prismicData.content) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InspirationHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        inspiration: prismicData.content.inspirationPage[0]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    sx: {
                                        position: "sticky",
                                        top: "172px"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_Image__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                        image: prismicData.content.inspirationPage[0].image
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                            sx: {
                                gridColumn: [
                                    "span 0",
                                    null,
                                    "span 1",
                                    null
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                            sx: {
                                gridColumn: [
                                    "span 2",
                                    null,
                                    "span 10",
                                    null
                                ]
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    sx: {
                                        display: [
                                            "none",
                                            null,
                                            null,
                                            "block"
                                        ]
                                    },
                                    children: (prismicData === null || prismicData === void 0 ? void 0 : (ref1 = prismicData.content) === null || ref1 === void 0 ? void 0 : ref1.inspirationPage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InspirationHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        inspiration: prismicData.content.inspirationPage[0]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    sx: {
                                        mt: "s11",
                                        mb: "s10"
                                    },
                                    children: categoryProducts.map(function(product, index) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            sx: {
                                                mt: "s9"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MinifiedProductPanel__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                showOptionsSelector: false,
                                                product: product,
                                                addToCartDisabled: addToCartDisabled
                                            }, index)
                                        });
                                    })
                                }),
                                (prismicData === null || prismicData === void 0 ? void 0 : (ref2 = prismicData.content) === null || ref2 === void 0 ? void 0 : ref2.inspirationPage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InfluencerBio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    influencerData: prismicData.content.inspirationPage[0].influencerData
                                })
                            ]
                        })
                    ]
                })
            }),
            (prismicData === null || prismicData === void 0 ? void 0 : (ref3 = prismicData.content) === null || ref3 === void 0 ? void 0 : ref3.inspirations) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: translations.peopleLiked,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_Grid2Cards__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        children: prismicData.content.inspirations.map(function(inspiration, index) {
                            return inspiration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                                sx: {
                                    marginTop: index > 1 ? "s11" : 0,
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InspirationCard__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    inspiration: inspiration
                                }, index)
                            }, index);
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (InspirationPage);


/***/ }),

/***/ 10753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ inspirations_list; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../helpers/dist/langLibrary/index.js
var langLibrary = __webpack_require__(51493);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Container/index.js
var Container = __webpack_require__(58709);
var Container_default = /*#__PURE__*/__webpack_require__.n(Container);
// EXTERNAL MODULE: ./src/containers/UI/PageContainer/index.js + 2 modules
var PageContainer = __webpack_require__(73764);
// EXTERNAL MODULE: ./src/sections/SectionWithConfigurableHeader/index.js
var SectionWithConfigurableHeader = __webpack_require__(44553);
// EXTERNAL MODULE: ./src/components/InspirationCard/index.js
var InspirationCard = __webpack_require__(15845);
// EXTERNAL MODULE: ./src/sections/Grid2Cards/index.js
var Grid2Cards = __webpack_require__(90485);
// EXTERNAL MODULE: ../sections/dist/CategoriesTagsSlider/index.js
var CategoriesTagsSlider = __webpack_require__(86144);
// EXTERNAL MODULE: ../components-new/dist/buttons/Button/index.js
var Button = __webpack_require__(51586);
;// CONCATENATED MODULE: ./src/sections/CategoriesTagsSlider/index.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CategoriesTagsSlider_CategoriesTagsSlider = function(props) {
    var propsExt = _objectSpread({}, props, {
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {})
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesTagsSlider/* default */.Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ var sections_CategoriesTagsSlider = (CategoriesTagsSlider_CategoriesTagsSlider);

;// CONCATENATED MODULE: ./src/pages/c/inspirations-list.js









var InspirationsListPage = function(props) {
    var backLabel = props.backLabel, backClickFunction = props.backClickFunction, inspirations = props.inspirations, categoryName = props.categoryName, dataRequiredToHideLoader = props.dataRequiredToHideLoader, subcategories = props.subcategories, footerContent = props.footerContent;
    var translations = {
        seoDescription: (0,langLibrary["default"])("Default seo description"),
        seoTitle: (0,langLibrary["default"])("Default seo title"),
        peopleLiked: (0,langLibrary["default"])("People also liked")
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
        returnLinkLabel: backLabel,
        onReturnLabelClick: backClickFunction,
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        dataRequiredToHideLoader: dataRequiredToHideLoader,
        footerContent: footerContent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWithConfigurableHeader/* default */.Z, {
            title: categoryName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CategoriesTagsSlider, {
                        categories: subcategories
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                    margin: [
                        0,
                        null,
                        null,
                        "s13"
                    ],
                    children: inspirations && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2Cards/* default */.Z, {
                        children: inspirations.map(function(inspiration, index) {
                            return inspiration && /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCard/* default */.Z, {
                                inspiration: inspiration
                            }, index);
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var inspirations_list = (InspirationsListPage);


/***/ }),

/***/ 31305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_MenuItemsList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87627);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MenuItemsList = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_MenuItemsList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (MenuItemsList);


/***/ }),

/***/ 94918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_RectangleCardWithLabelInsideSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26034);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RectangleCardWithLabelInsideSection = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_RectangleCardWithLabelInsideSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (RectangleCardWithLabelInsideSection);


/***/ }),

/***/ 49308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_SquareCardWithLabelSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44102);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SquareCardWithLabelSection = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_SquareCardWithLabelSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (SquareCardWithLabelSection);


/***/ })

}]);